import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

type SliceMode = "whole" | "half" | "quarters";

interface Props {
  selected: SliceMode[];
  onChange: (modes: SliceMode[]) => void;
}

const sliceModesList: { id: SliceMode; label: string }[] = [
  { id: "whole", label: "Entera" },
  { id: "half", label: "Mitad y Mitad" },
  { id: "quarters", label: "Por Cuartos" },
];

export const SliceModeSelector = ({ selected, onChange }: Props) => {
  const toggle = (id: SliceMode) => {
    onChange(
      selected.includes(id)
        ? selected.filter((x) => x !== id)
        : [...selected, id]
    );
  };

  return (
    <List dense>
      {sliceModesList.map((mode) => (
        <ListItem key={mode.id} disablePadding>
          <ListItemButton onClick={() => toggle(mode.id)}>
            <Checkbox checked={selected.includes(mode.id)} />
            <ListItemText primary={mode.label} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};
